import { render, staticRenderFns } from "./ReferralAgentsForm.vue?vue&type=template&id=5c66bce0"
import script from "./ReferralAgentsForm.vue?vue&type=script&lang=js"
export * from "./ReferralAgentsForm.vue?vue&type=script&lang=js"
import style0 from "./ReferralAgentsForm.vue?vue&type=style&index=0&id=5c66bce0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports